import { useNavigate } from 'react-router-dom';
import { ReactComponent as SearchIcon } from '@/assets/steam/search-icon.svg';
import './Quote.scss';
import { useEffect, useState, useRef } from 'react';
import BackIcon from '@/assets/rewise/back-icon.svg';
import { ArchiveIcon } from '@heroicons/react/outline';
import { User, Location, UserRole, State } from '../types/indes';
import { showNotification } from '@/utils/notificationUtils';
import { Loader } from '@/components/Loader/Loader';
import noDataAnimation from '@/assets/animation/loading.json';
import Lottie from 'lottie-react';
import Filter, { ReactComponent as ProductIcon } from '@/assets/steam/product.svg';
import Delete from '@/assets/steam/delete.svg';
import View from '@/assets/steam/view.svg';
import Edit from '@/assets/steam/edit.svg';
import { TableData } from '@/components/Table/TableData';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import Utils from '@/utils/util';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useGetStateList, useGetUserRoleList } from '../api/getRefrences';
import { FilterMenu } from '@/components/Elements/FilterMenu';
import { useGetInstituteList, useGetProductList, useGetQuotesList, useGetUsersListForQuotes } from '@/features/quote/api/getProductsList';
import TYPES, { QUOTES_STATUS } from '@/utils/constants';
import { QuotesFilter } from '@/components/Elements/QuotesFilter';
import UpdateQuote from '../components/updateQuote';
import { useGetQuoteDetails } from '@/features/funnel/api/quotesApi';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

export const Quote = () => {
  const [quotesList, setQuotesList] = useState<User[]>([]);
  const [isAddNewUser, setIsAddNewUser] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableCurrentIndex, setTableCurrentIndex] = useState(1);
  const perPage = 10;
  const [searchString, setSearchString] = useState('');
  const [filteredList, setFilteredList] = useState<any[]>([]);
  const [productList, setProductList] = useState<any[]>();
  const useGetUsersMutation = useGetProductList();
  const useGetQuotesMutation = useGetQuotesList();
  const [roles, setRoles] = useState<UserRole[]>([]);
  const useGetUserRoleMutation = useGetUserRoleList();
  const [states, setStates] = useState<State[]>([]);
  const [editUserData, setEditUserData] = useState<any>(null);
  const [usersList, setUsersList] = useState<User[]>([]);
  const [editQuote, setEditQuote] =useState<any>('')
  const useGetUsersMutations = useGetUsersListForQuotes();
  const useGetInstituteMutations = useGetInstituteList();
  const [instituteList, setInstituteList] = useState<any[]>([]);
  const [filteredValue, setFilteredValue] = useState<any>();
  const useGetQuoteDetailsMutation =useGetQuoteDetails();

  useEffect(() => {
    getProductList(1, true);
    getQuotesList(1, true);
    getUserList(1);
    getInstituteDetails(1)
   // getUserRoleList()
  }, []);

  const getUserList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetUsersMutations.mutateAsync({
      page: pageIndex,
      perPage: 500,
      search: '',
      filter: { 'rolesId': [1, 2, 3, 4] },
    });
    setUsersList(res.list);

  };

  const getInstituteDetails = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetInstituteMutations.mutateAsync({
      page: pageIndex,
      perPage: 500,
      search: '',
    });
    setInstituteList(res.list);

  };

  const getQuoteDetailss = async(id:any) =>{

    const res = await useGetQuoteDetailsMutation.mutateAsync({
      id:id
    });
   
    if(res?.details){
     setEditQuote(res?.details);
    }
  }

  const getUserRoleList = async () => {
    const res = await useGetUserRoleMutation.mutateAsync({
      search: ''
    });
    if (res) {
      const filteredRoles = res.list.filter((item: any) => {
        const id = Number(item.id);
        return id !== 1 && id !== 5 && id !== 6;
      });
      setRoles(filteredRoles);

    }
  };

  const getProductList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetUsersMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter 
    });

    setProductList(res?.list);
  };

  const getQuotesList = async (pageIndex: number, reset = false, filter?: any) => {
    const res = await useGetQuotesMutation.mutateAsync({
      page: pageIndex,
      perPage: perPage,
      search: searchString,
      filter: filter? filter : filteredValue? filteredValue :  null,
    });

    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
    if (reset) {
      setQuotesList(res.list);
      setTableCurrentIndex(1);
      if (searchString) {
        setFilteredList(res.list);
      }
    } else {
      setQuotesList(quotesList.concat(res.list));
      setTableCurrentIndex(pageIndex);
    }
  };

  const searchUser = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchString = e.target.value;
    setSearchString(searchString);
    const res = await useGetQuotesMutation.mutateAsync({
      page: 1,
      perPage: perPage,
      search: searchString,
    });
    setQuotesList(res.list);
    if (searchString) {
      setFilteredList(res.list);
    } else {
      setFilteredList([]);
    }
    setTotalPages(res.totalPages);
    setTotalRecords(res.total);
  };

  const actualList = filteredList.length ? filteredList : quotesList;
 
//   const actualList = (filteredList.length ? filteredList : quotesList).sort((a, b) => {
//     const nameA = a.createdByUser?.name?.toLowerCase() || '';
//     const nameB = b.createdByUser?.name?.toLowerCase() || '';
//     return nameA.localeCompare(nameB);
// });


  const onTableStateChange = (pageIndex: number) => {
    if (totalPages >= pageIndex) {
      getQuotesList(pageIndex, true);
    }
  };

  const getStates = (location: any) => {
    if (location && location.length > 0) {
      const states = location.map((loc: any) => loc.state);
      const uniqueStates = Array.from(new Set(states.map((state: any) => state.id)))
        .map((id) => states.find((state: any) => state.id === id)?.name);

      const firstThreeStates = uniqueStates.slice(0, 2);
      const remainingCount = uniqueStates.length - 2;

      return {
        firstThreeStates,
        remainingCount: remainingCount > 0 ? remainingCount : 0,
      };
    }
    return { firstThreeStates: [], remainingCount: 0 };
  };

  const getStatusName = (statusId: any) => {
    if (statusId === QUOTES_STATUS.REQUESTED) {
      return 'Requested'
    } else if (statusId === QUOTES_STATUS.REJECTED) {
      return 'Rejected'
    } else if (statusId === QUOTES_STATUS.COMPLETED) {
      return 'Uploaded'
    } else {
      return ''
    }
  }

  const getRoleName = (userRoleId: any) => {
    if (userRoleId === TYPES.SUPER_ADMIN) {
      return 'Super Admin'
    } else if (userRoleId === TYPES.SALES_EXECUTIVE) {
      return 'Sales Executive'
    } else if (userRoleId === TYPES.SALES_MANAGER) {
      return 'Sales Manager'
    } else if (userRoleId === TYPES.SALES_HEAD) {
      return 'Sales Head'
    } else if (userRoleId === TYPES.MARKETING) {
      return 'Marketing'
    } else if (userRoleId === TYPES.ACCOUNTS) {
      return 'Accounts'
    }

    else {
      return 'Super Admin'
    }
  }

  const QuotesStatus = [
    {id: 1 , name : 'Requested'},
    {id: 3 , name : 'Uploaded'},
    {id: 4 , name : 'Rejected'},
  ]

  return (
    <>

      <div className="users-list-container">
        <PageHeader title='Quotes' description='' />
        <div className='search-container'>
          <div className='search-filter-container'>

            <span className="search-content">
              <SearchIcon />
              <input
                type="text"
                id="simple-search"
                placeholder="Search by name, title, price.."
                onChange={searchUser}
                className="steam-search"
              />
            </span>
            <div>
              <div className="action-btn">
                <QuotesFilter showInstitute={true} instituteList={instituteList} roles={QuotesStatus} usersList={usersList} options={[]} onRoleSelect={(filter: any) => {
                  if (filter) {
                    setFilteredValue(filter);
                    getQuotesList(1, true, filter);
                  } else {
                    setFilteredValue(null);
                    getQuotesList(1, true)
                  }
                }} showRoleFilter={false} />
              </div>
            </div>

          </div>
        </div>
        <div className="users-list petsked-table">
          {useGetUsersMutation.isLoading && !searchString && (
            <div className="h-full w-full flex items-center justify-center  ">
              <Lottie className="loading-loader-class" animationData={noDataAnimation} />
            </div>
          )}

          <TableData<any>
            data={actualList}
            columns={[
              {
                title: 'Institute',
                field: 'name',
                Cell({ entry: { institute } }) {
                  return (
                    <div className="users-container">
                      <div>
                        <InitialsAvatar name={institute && institute.name ? institute.name : 'SA'} className="avatar" />
                      </div>
                      <div className="user-details-container">

                        <div className="user-tab-name">
                          <div className="name">{institute?.name}</div>
                          <div className="email address">{institute?.address}</div>
                        </div>
                      </div>
                    </div>
                  );
                },
              },
              {
                title: 'Requested By',
                field: 'name',
                Cell({ entry: { createdByUser } }) {
                  return (
                    <div className="table-user-role">{createdByUser?.name}
                          {/* <div className="email">{createdByUser?.email}</div> */}
                        </div>
                  );
                },
              },
              {
                title: 'User Role',
                field: 'userRole',
                Cell({ entry: { createdByUser } }) {
                  return (
                    <div className="table-user-role">
                      {getRoleName(Number(createdByUser?.userRoleId))}

                    </div>
                  );
                },
              },
              {
                title: 'Title',
                field: 'userRole',
                Cell({ entry: { title } }) {
                  return (
                    <div className="table-user-role">
                      {title}

                    </div>
                  );
                },
              },
              {
                title: 'Price',
                field: 'phone',
                Cell({ entry: { requestedPrice } }) {
                  return (
                    <div className="table-contact">
                      {Utils.convertDealSize(requestedPrice)}

                    </div>
                  );
                },
              },
              {
                title: 'Status',
                field: 'phone',
                Cell({ entry: { statusId } }) {
                  return (
                    <div className={`table-contact ${getStatusName(Number(statusId)) === 'Uploaded' ? 'uploaded' :'' } ${getStatusName(Number(statusId)) === 'Rejected' ? 'rejected' :''}`}>
                      {getStatusName(Number(statusId))}

                    </div>
                  );
                },
              },
              {
                title: 'Last Update',
                field: 'createdAt',
                Cell({ entry: { updatedAt, createdAt, statusId } }) {
                  return (
                    <div className="table-date">
                       <OverlayTrigger
                                                    placement="top"
                                                    overlay={
                                                        <Tooltip id="tooltip-id" className="service-provider-tooltip">
                                                                <div className="service-name">
                                                               { getStatusName(Number(statusId)) === 'Uploaded' ? 'Approved on:' : getStatusName(Number(statusId)) === 'Rejected' ? 'Rejected on:': 'Requested on:'} {Utils.formatDate(
                     getStatusName(Number(statusId)) === 'Uploaded' ?    updatedAt : getStatusName(Number(statusId)) === 'Rejected' ? updatedAt : createdAt
                      )}
                                                                </div>
                                                        </Tooltip>
                                                    }
                                                >
                                                    <span
                                                        className="tooltip-owner-name default table-contact  font-vale"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                         {Utils.formatDate(
                        updatedAt
                      )}
                                                    </span>
                                                </OverlayTrigger>
                    
                    </div>
                  );
                },
              },

              {
                title: 'Action',
                field: 'id',
                Cell({ entry }) {
                  return (
                    <div className="user-btn-container">

                      <div className="edit-btn" onClick={() => {getQuoteDetailss(entry?.id)  }} >
                        <img src={Edit} />
                      </div>
                      {/* <div
                        className="view-btn"
                      >
                        <img src={Delete} />
                      </div> */}
                    </div>
                  );
                },
              },
            ]}
            tableInitialState={{
              tableTotalRecords: totalPages,
              tablePageIndex: tableCurrentIndex,
            }}
            onTableStateChange={onTableStateChange}
            showPagination={true}
            isDataLoading={useGetUsersMutation?.isLoading}
          />
        </div>


      </div>
      <UpdateQuote quoteDetails={editQuote} open={editQuote ? true :  false} onClose={()=>{setEditQuote('')}} onConfirm={()=>{setEditQuote('');getQuotesList(1, true)}}/>

    </>
  );
};
